import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import './App.css';
//import 'antd/dist/antd.css'; 
import 'antd/dist/result.css';
import 'leaflet/dist/leaflet.css';

import { connect } from 'react-redux'
import * as actions from './store/actions/auth'
import { BrowserRouter as Router } from 'react-router-dom'

import LoginLayout from './views/LoginLayout'
import SaccoLayout from './views/MainBranch/containers/Saccoslayout'
import HubLayout from './views/MainBranch/containers/HubLayout'
import ConditionalRouter from './views/MainBranch/containers/ConditionalRouter'
import LoginBaseRouter from './loginroutes'
import { backendserverurl } from './views/serverconn'

// Containers

class App extends Component {
  state = {
    userprofile: {},
    loading: true
  };

  componentDidMount(){
    this.props.onTryAutoSignup();
    this.fetchUserProfile();
  }

  fetchUserProfile = () => {
    const token = localStorage.getItem('token');
    console.log('🔍 App: Token from localStorage:', token);
    
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      };

      // Import axios dynamically to avoid issues
      import('axios').then(axios => {
        axios.default.get(`${backendserverurl}/current_user_profile`, { headers })
          .then(res => {
            console.log('🔍 App: User profile data:', res.data);
            this.setState({
              userprofile: res.data,
              loading: false
            });
          })
          .catch(err => {
            console.error('🔍 App: Error fetching user profile:', err);
            this.setState({ loading: false });
          });
      });
    } else {
      this.setState({ loading: false });
    }
  };

  render() {
    if (!this.props.isAuthenticated) {
      return (
        <Router>
          <LoginLayout>
            <LoginBaseRouter />
          </LoginLayout>
        </Router>
      );
    }

    const { userprofile, loading } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    // Check if user is a hub manager (has coodinated_hub assigned)
    const isHubManager = userprofile.coodinated_hub !== null && userprofile.coodinated_hub !== undefined;
    console.log('🔍 App: isHubManager:', isHubManager, 'coodinated_hub:', userprofile.coodinated_hub);

    return (
      <Router>
        {isHubManager ? (
          <HubLayout {...this.props}>
            <ConditionalRouter />
          </HubLayout>
        ) : (
          <SaccoLayout {...this.props}>
            <ConditionalRouter />
          </SaccoLayout>
        )}
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null
  }
}

const mapDispatchToProps = dispatch =>{
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
